<template>
  <div class="company_card">
    <el-card :class="{ inpageCla: inpage }">
      <el-form
        :rules="rules"
        :model="companyDetails"
        ref="companyDetailsForm"
        label-width="140px"
      >
        <div class="accountInfo_header_cla">
          {{ this.$t('company.accountInfo') }}
        </div>
        <div class="flex-display-cla">
          <div style="flex-grow: 1;">
            <div class="flex-display-cla">
              <el-form-item
                class="form-item-cla flex-item-cla"
                :label="this.$t('company.code')"
                prop="companyCode"
              >
                <el-input
                  :disabled="true"
                  v-model.trim="companyDetails.companyCode"
                ></el-input>
              </el-form-item>
              <el-form-item
                class="form-item-cla flex-item-cla"
                :label="this.$t('company.webSite')"
                prop="website"
              >
                <el-input v-model.trim="companyDetails.website"></el-input>
              </el-form-item>
            </div>
            <div class="flex-display-cla">
              <el-form-item
                class="flex-item-cla"
                :label="this.$t('company.name')"
                prop="companyName"
              >
                <el-input v-model.trim="companyDetails.companyName"></el-input>
              </el-form-item>
              <el-form-item
                class="flex-item-cla"
                :label="this.$t('company.industry')"
                prop="industry"
              >
                <el-input v-model.trim="companyDetails.industry"></el-input>
              </el-form-item>
            </div>
          </div>

          <el-form-item class="logo">
            <el-upload
              class="upload-demo"
              action="/apiv1/hr/company/uploadCompanyLogo"
              :show-file-list="false"
              :data="datas"
              :on-success="handleAvatarSuccess"
              :on-error="uploadError"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imgUrl" :src="imgUrl" class="avatar" />
              <div v-else class="upload_div">
                <i class="el-icon-plus el-icon-upload"></i>
              </div>
            </el-upload>
          </el-form-item>
        </div>

        <el-divider></el-divider>

        <div class="companyContactInfo_cla">
          {{ this.$t('company.companyContactInfo') }}
        </div>

        <div class="contact-panel-cla flex-display-cla">
          <el-form-item
            class="form-item-cla flex-item-cla contact-cla formatted-name-cla"
            :label="this.$t('company.Contact')"
            prop="name"
          >
            <el-row>
              <el-col :span="11">
                <el-form-item prop="firstName">
                  <el-input
                    class="contact_input"
                    :placeholder="this.$t('employee.firstName')"
                    v-model.trim="companyDetails.firstName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11" :offset="2">
                <el-form-item prop="lastName">
                  <el-input
                    style="margin-left:8px"
                    class="contact_input"
                    :placeholder="this.$t('employee.lastName')"
                    v-model.trim="companyDetails.lastName"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item
            class="form-item-cla flex-item-cla contact-cla"
            :label="this.$t('company.country')"
            prop="countryCode"
          >
            <el-select
              @change="changeCountry"
              v-model.trim="companyDetails.countryCode"
              filterable
              placeholder
              style="width:100%"
            >
              <el-option
                v-for="item in contryCode"
                :key="item.value"
                :label="item.key"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="contact-panel-cla">
          <div class="flex-display-cla">
            <el-form-item
              style="width: 50%;"
              class="form-item-cla flex-item-cla"
              :label="this.$t('company.phone')"
              prop="phone"
            >
              <el-input v-model="companyDetails.phone">
                <template slot="prepend"
                  >+{{ phonePrefix }}</template
                >
              </el-input>
            </el-form-item>

            <el-form-item
              style="width:50%"
              class="form-item-cla flex-item-cla"
              :label="this.$t('company.email')"
              prop="email"
            >
              <el-input v-model.trim="companyDetails.email"></el-input>
            </el-form-item>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="header-button-bar">
          <el-button :loading="isLoad" @click.stop="saveEvent" type="primary">
            {{ $t('common.save') }}
          </el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import * as companyApi from '@/services/companyApi'
import { deleteCompany } from '@/services/tenantSettingApi.js'
import {
  validatorEmailRule,
  validatorInputEmptyRule,
  validatorPhoneRule
} from '@/utils/validatorRule.js'
export default {
  data() {
    let checkPhone = (rules, value, callback) => {
      if (this.sourceData.phone && value.substr(3, 5) === '*****') {
        if (value !== this.phoneFormat(this.sourceData.phone)) {
          return callback(new Error(window.vm.$t('common.phoneValid')))
        }
      }
      callback()
    }
    let checkEmail = (rules, value, callback) => {
      if (
        this.sourceData.email &&
        (value.substr(2, 3) === '***' || value.substr(1, 3) === '***')
      ) {
        if (value !== this.emailFormat(this.sourceData.email)) {
          return callback(new Error(window.vm.$t('common.emailValid')))
        }
      }
      callback()
    }
    return {
      isLoad: false,
      rules: {
        companyCode: validatorInputEmptyRule(true, 32),
        website: validatorInputEmptyRule(false, 100),
        companyName: validatorInputEmptyRule(true, 100),
        industry: validatorInputEmptyRule(false, 100),
        email: validatorEmailRule(true, checkEmail),
        firstName: validatorInputEmptyRule(false, 32),
        lastName: validatorInputEmptyRule(false, 32),
        phone: validatorPhoneRule(false, checkPhone),
        name: [{ required: false }]
      },
      companyDetails: {
        id: '',
        logo: '',
        companyCode: '',
        companyName: '',
        website: '',
        Integrator: '',
        active: '',
        status: '',
        city: '',
        province: '',
        zip: '',
        countryCode: '',
        phone: '',
        email: '',
        industry: '',
        dateFormat: '',
        timeFormat: '',
        lastUpdateTimeStamp: '',
        createdDate: '',
        modifiedDate: '',
        appKey: '',
        language: '',
        firstName: '',
        lastName: ''
      },
      phonePrefix: '',
      Langus: [],
      contryCode: [],
      contryData: {},
      params: {
        companyId: ''
      },
      datas: {
        id: ''
      },
      isWrite: false,
      sourceData: {
        email: '',
        phone: ''
      },
      imgUrl: ''
    }
  },
  filters: {
    formatDate(val) {
      if (val) {
        return val.substr(0, 10)
      }
      return ''
    }
  },

  mounted() {
    this.getCompanyInfo()
    this.loadLangus()
    this.loadContryCode()
  },
  props: {
    company: {
      type: String,
      default: ''
    },
    inpage: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    company: {
      handler: function(val, oVal) {
        if (val) {
          this.params.companyId = val
          this.getCompanyInfo()
        } else {
          this.companyDetails = {}
        }
      },
      deep: true
    },
    'companyDetails.logo': {
      handler(val) {
        if (val) {
          this.companyDetails.logo = val
        }
      },
      immediate: true
    }
  },

  methods: {
    deleteCompany() {
      this.$confirm(
        this.$t('companyList.deletCompany'),
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          let params = {
            companyId: this.params.companyId
          }
          this.showLoad()
          deleteCompany(params)
            .then(data => {
              if (data.code === '00000000') {
                this.$message.success(this.$t('operationMsg.deleteSuc'))
              } else {
                this.$message.error(data.message)
              }
            })
            .catch(e => {})
            .finally(() => this.closeLoad())
        })
        .catch(() => {})
    },
    uploadError() {
      this.$message.error(this.$t('common.uploadFail'))
    },
    handleAvatarSuccess(res, fileInfo) {
      if (res.code === '00000000') {
        this.companyDetails.logo = res.payload.results.url
        this.imgUrl = res.payload.results.url
        this.$message.success(this.$t('common.uploadSuccess'))
      } else {
        this.$message.error(res.message)
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = ['image/jpeg', 'image/png'].includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error(this.$t('common.uploadCompanyLogo'))
        return false
      }
      if (!isLt2M) {
        this.$message.error(this.$t('common.uploadCompanyLogoSize'))
        return false
      }
      return isJPG && isLt2M
    },
    getCompanyInfo() {
      if (this.params.companyId === '') {
        this.params = {}
      }
      companyApi
        .getCompanyDetails(this.params)
        .then(data => {
          if (data.code === '00000000') {
            let companyDetails = data.payload.results.companyDetails
            this.imgUrl = companyDetails.logo
            if (!companyDetails.phone) {
              companyDetails.phone = ''
            }

            if (companyDetails) {
              // 电话前缀问题bug
              if (this.companyDetails.countryCode) {
                this.phonePrefix = ''
              }
              this.sourceData.email = companyDetails.email
              this.sourceData.phone = companyDetails.phone

              this.companyDetails = companyDetails

              this.companyDetails.email = this.emailFormat(
                this.companyDetails.email
              )
              this.companyDetails.phone = this.phoneFormat(
                this.companyDetails.phone
              )

              if (this.companyDetails && this.companyDetails.countryCode) {
                this.changeCountry(this.companyDetails.countryCode)
              }
              this.datas.id = companyDetails.id
            } else {
              this.isWrite = true
            }
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(data => {
          // this.errorMessage()
        })
    },
    saveEvent() {
      this.updateCompanyDetails()
    },
    updateCompanyDetails() {
      this.$refs.companyDetailsForm.validate(valid => {
        if (valid) {
          this.isLoad = true

          let result = Object.assign({}, this.companyDetails)

          if (result.email === this.emailFormat(this.sourceData.email)) {
            result.email = this.sourceData.email
          }
          if (result.phone === this.phoneFormat(this.sourceData.phone)) {
            result.phone = this.sourceData.phone
          }
          companyApi
            .updateCompanyDetails(result)
            .then(data => {
              this.isLoad = false
              if (data.code === '00000000') {
                this.$message({
                  message: this.$t('common.saveSucess'),
                  type: 'success'
                })
                this.getCompanyInfo()
              } else {
                this.errorMessage(data.message)
              }
            })
            .catch(data => {
              this.isLoad = false
              this.errorMessage()
            })
        }
      })
    },
    searchDateFormat(queryString, cb) {
      companyApi.loadDateFormat(queryString).then(results => {
        cb(results)
      })
    },
    searchTimeFormat(queryString, cb) {
      companyApi.loadTimeFormat(queryString).then(results => {
        cb(results)
      })
    },
    loadContryCode() {
      companyApi.loadCountry().then(data => {
        this.contryCode = []
        this.contryData = data
        let key = Object.keys(data)
        key.forEach(item => {
          this.contryCode.push({
            key: this.$t('contry.' + item),
            value: item
          })
        })
      })
    },
    loadLangus() {
      setTimeout(() => {
        companyApi.loadLangus(this).then(data => {
          this.Langus = data
        })
      }, 200)
    },
    changeCountry(data) {
      let phonePrefix = this.contryData[data]
      if (phonePrefix) {
        this.phonePrefix = phonePrefix
      }
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
/deep/ .el-dialog__body {
  /deep/ .el-form {
    display: flex;
    justify-content: flex-start;
  }
}

.formatted-name-cla {
  /deep/ .el-form-item--small {
    margin-bottom: 0px;
  }
}
/deep/ .logo .el-form-item__content {
  margin-left: 0px !important;
}
.inpageCla {
  border: none;
  padding-top: 20px;
  /deep/ .el-card__body {
    padding: 0px !important;
    box-shadow: none;
  }
  .upload-demo {
    margin-left: 22px;
  }
  .contact-panel-cla {
    padding-right: 106px;
  }
  .avatar {
    width: 82px;
    height: 82px;
    border: 1px dashed #d9d9d9;
    overflow: hidden;
  }
}
.el-divider--horizontal {
  margin: 0px;
}

.el-upload__tip {
  display: none;
}

.contact-cla {
  width: 50%;
  /deep/ .el-form-item__content {
    display: flex;
  }
}

.flex-display-cla {
  display: flex;
  .flex-item-cla {
    flex-grow: 1;
  }
}

.form-item-cla {
  flex-grow: 1;
}
.contact-panel-cla {
  padding-right: 156px;
}
.upload-demo {
  margin-left: 72px;
  .upload_div {
    width: 82px;
    height: 82px;
    line-height: 82px;
    border: 1px dashed #d9d9d9;
    border-radius: 3px;
    font-size: 20px;
    background-color: #f4f6fa;
  }
  .upload_div:hover {
    border-color: #7ac143;
    color: #7ac143;
  }
  .el-upload__tip {
    width: 400px;
  }
}

.com_header_cla {
  height: 22px;
  line-height: 22px;
  color: @fontColor1;
  font-weight: 600;
  padding-left: 16px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.9);
  letter-spacing: 0;
  position: relative;

  &::after {
    position: absolute;
    top: 3px;
    left: 0px;
    content: '';
    height: 16px;
    width: 4px;
  }
}

.accountInfo_header_cla {
  .com_header_cla;
  margin-bottom: 20px;
  &::after {
    background: @themeColor;
  }
}

.companyContactInfo_cla {
  margin: 20px 0px;
  .com_header_cla;
  &::after {
    background: @ststusFailed;
  }
}

.header-button-bar {
  margin-top: 20px;
}
img.avatar {
  width: 82px;
  height: 82px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/modules/comComponent/comPanyInfo.vue